import { gql } from '@apollo/client'

export const GET_BUSINESS_CLIENTS_SUGGESTIONS = gql`
  query GetBusinessClientsSuggestions($input: BusinessClientSuggestionsInput!) {
    businessClientSuggestions(input: $input, sorting: { field: "name", order: 1 }) {
      items {
        id
        name
        verticals
      }
    }
  }
`

export const GET_BUSINESS_CLIENT = gql`
  query GetBusinessClient($id: UUID!) {
    businessClient(id: $id) {
      kreditsSettings {
        categories {
          amount
          frequency {
            unit
            value
          }
          name
        }
      }
      companies {
        id
        name
        vertical
      }
      contacts {
        company {
          id
          name
          vertical
        }
        email
        id
        name
        phone
        secondaryEmail
        secondaryPhone
      }
      createdAt
      emailDomains
      shareCustomersData
      id
      isActive
      kamUser {
        firstName
        id
        lastName
      }
      logo {
        name
        path
      }
      name
      updatedAt
      processedMobileLineFiles {
        id
        processedAmount
        processedAt
        processedBy {
          firstName
          id
          lastName
        }
      }
      kreditDeposits {
        id
        amount
        user {
          id
          firstName
          lastName
        }

        createdAt
      }
    }
  }
`

export const GET_BUSINESS_CLIENTS = gql`
  query GetBusinessClients($input: BusinessClientsInput, $sorting: SortingV2, $pagination: PaginationV2) {
    businessClients(input: $input, sorting: $sorting, pagination: $pagination) {
      items {
        kreditsSettings {
          categories {
            amount
            frequency {
              unit
              value
            }
            name
          }
        }
        companies {
          id
          name
          vertical
        }
        contacts {
          company {
            id
            name
            vertical
          }
          email
          id
          name
          phone
          secondaryEmail
          secondaryPhone
        }
        numberOfSites
        numberOfCustomers
        createdAt
        emailDomains
        id
        isActive
        kamUser {
          firstName
          id
          lastName
        }
        logo {
          name
          path
        }
        name
        updatedAt
      }
      total
    }
  }
`
